import React from "react";
import { Row, Col } from "react-flexbox-grid";
import { Player } from "video-react";
// SCSS
import "./hero.scss";
// Assets
import HeroVideo from "../../assets/hero/hero.mov";
// Components
import {
  AppStoreButton,
  ButtonsContainer,
  GooglePlayButton,
} from "react-mobile-app-button";
import "video-react/dist/video-react.css";

const hero = () => {
  const APKUrl =
    "https://play.google.com/apps/internaltest/4701682705249965256";
  const iOSUrl = "https://testflight.apple.com/join/JFrCBayU";

  return (
    <div className="hero" id="hero">
      <div className="wrapper">
        <Row middle="sm">
          <Col md={12} lg={6}>
            <div className="hero-info">
              <h1 className="weight500 font20" style={{ paddingBottom: 6, paddingLeft: 3 }}>
                MyVolunteerWorld
              </h1>
              <h1 className="weight800 font60 hero-subtitle">
                Your Efforts, Our Collective Future
              </h1>
              <p className="font14">
                MyVolunteerWorld is a trust-based platform that enables
                volunteers to log their social work and generate “Effort
                Currency” that will be redeemable within the ecosystem.
              </p>

              <ButtonsContainer>
                {/* APK Download Button */}
                <a href={APKUrl} target="_blank" rel="noopener noreferrer">
                  <GooglePlayButton
                    url={APKUrl}
                    theme={"dark"}
                    className={"download-btn-custom-style"}
                  />
                </a>

                {/* TestFlight for iOS */}
                {iOSUrl && (
                  <a href={iOSUrl} target="_blank" rel="noopener noreferrer">
                    <AppStoreButton
                      url={iOSUrl}
                      theme={"dark"}
                      className={"download-btn-custom-style"}
                    />
                  </a>
                )}
              </ButtonsContainer>
              <p>Want early access? <a href="https://chat.whatsapp.com/GZS9CkLlupt4Q2QZBXFxLF" target="_blank" rel="noopener noreferrer">Share your email ID here</a> to join the beta testing program. Let's build something amazing together!</p>

            </div>
          </Col>
          <Col md={12} lg={6} style={{ marginTop: "3rem" }}>
            <div className="hero-video">
              <Player
                className="video-player "
                src={HeroVideo}
                loop
                controls={false}
                playsInline={true}
                fluid={true}
                muted={true}
                autoPlay={true}
                width="100%"
                height="auto"
              />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default hero;
